export default "__VITE_ASSET__71cdc752__"